import { api } from './client';

// Analytics API
export interface AnalyticsOverview {
  tasks: {
    total_tasks: number;
    completed_tasks: number;
    in_progress_tasks: number;
    todo_tasks: number;
    review_tasks: number;
    overdue_tasks: number;
  };
  projects: {
    total_projects: number;
    active_projects: number;
    completed_projects: number;
    on_hold_projects: number;
  };
  users: {
    total_users: number;
    active_users: number;
    admin_count: number;
  };
  trends: {
    completions: { date: string; count: number }[];
    creations: { date: string; count: number }[];
  };
  topAssignees: {
    id: string;
    name: string;
    avatar_url?: string;
    completed_count: number;
  }[];
  tasksByPriority: {
    priority: string;
    count: number;
  }[];
  recentActivity: {
    id: string;
    action: string;
    entity_type: string;
    entity_id: string;
    changes: string;
    created_at: string;
    actor_name: string;
    actor_avatar?: string;
  }[];
}

export interface ProjectAnalytics {
  project: import('../types').Project;
  tasks: {
    total_tasks: number;
    completed_tasks: number;
    in_progress_tasks: number;
    todo_tasks: number;
    review_tasks: number;
    overdue_tasks: number;
  };
  tasksBySection: {
    section_id: string | null;
    section_name: string | null;
    total: number;
    completed: number;
  }[];
  tasksByAssignee: {
    id: string | null;
    name: string | null;
    avatar_url?: string;
    total: number;
    completed: number;
  }[];
  completionTrend: { date: string; count: number }[];
}

export const analyticsApi = {
  getOverview: () => api.get<AnalyticsOverview>('/analytics/overview'),
  getProjectAnalytics: (projectId: string) =>
    api.get<ProjectAnalytics>(`/analytics/project/${projectId}`),
};
